<template>
  <div class="paysuccessApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <div class="scon">
      <div style="height:30px;"></div>
      <img class="left" src="~assets/images/pay.jpg">
      <h2>恭喜您付款成功！</h2>
      <div class="ord">
        <p>{{setDetail.number}}</p>
        <p>支付时间：{{setDetail.paytime}}</p>
        <p>支付金额：{{setDetail.price}}元</p>
        <p>认购股份数量：{{setDetail.num}}股</p>
        <div style="height:15px;"></div>
      </div>
    </div>
    <button class="curt" @click="$router.push('crowd')">继续选购</button>
    <button @click="$router.push('index')">返回首页</button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        positionFlag:false
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDetail:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/userBuy',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .paysuccessApp{
    background:#ececec;
  }

  .paysuccessApp .scon{
    width:92%;
    margin:0 auto;
    background:#fff;
    border-radius:5px;
  }
  .paysuccessApp .scon img{
    display:block;
    margin:0 auto;
    width:180px
  }
  .paysuccessApp .scon h2{
    text-align:center;
    font-size:17px;
    color:#1980FF;
    font-weight:550;
    padding:10px 0 20px 0;
    letter-spacing:1px
  }

  .paysuccessApp .scon .ord p{
    font-size:15px;
    color:#666;
    text-align:center;
    padding-bottom:10px
  }
  .paysuccessApp button{
    display:block;
    width:85%;
    margin:0 auto;
    height:45px;
    border:#1980FF 1px solid;
    border-radius:40px;
    color:#1980FF;
    font-size:16px;
    font-weight:500;
    margin-top:30px;
  }
  .paysuccessApp button.curt{
    background:#1980FF;
    color:#fff
  }
</style>